module.exports = __webpack_public_path__ + "static/media/swimming.dd5a8975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/swimming.svg
// module id = 299
// module chunks = 0